import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  INICIA_SEQUENCIA_ENTURMACAO,
  SALVA_SEQUENCIA_ENTURMACAO,
  REMOVE_SEQUENCIA_ENTURMACAO,
  LISTA_SEQUENCIA_ENTURMACAO,
  BUSCA_SEQUENCIA_ENTURMACAO_EDICAO,
  ON_HIDE_LOADER
} from "constants/ActionTypes";
import requisicaoApi from 'util/Api';
import {
  showAuthMessage,
  inicioSequenciaEnturmacaoSucesso,
  listaSequenciaEnturmacaoSucesso,
  salvaSequenciaEnturmacaoSucesso,
  removeSequenciaEnturmacaoSucesso,
  buscaSequenciaEnturmacaoEdicaoSucesso
} from "actions/SequenciaEnturmacao";

/*#################################################################################################################*/
/* ---------------------------------- Helpers de Formatação --------------------------------------------------------*/

const formataLista = (lista) => {
  if (lista && lista.length > 0) {
    return lista.map(item => ({
      id: item.id || item.Id,
      escolaId: item.escolaId || item.EscolaId,
      escolaNome: item.escolaNome || item.EscolaNome || 'Escola não informada',
      cursoOrigemId: item.cursoOrigemId || item.CursoOrigemId,
      cursoOrigemNome: item.cursoOrigemNome || item.CursoOrigemNome || 'Curso Origem não informado',
      serieOrigemId: item.serieOrigemId || item.SerieOrigemId,
      serieOrigemNome: item.serieOrigemNome || item.SerieOrigemNome || 'Série Origem não informada',
      cursoDestinoId: item.cursoDestinoId || item.CursoDestinoId,
      cursoDestinoNome: item.cursoDestinoNome || item.CursoDestinoNome || 'Curso Destino não informado',
      serieDestinoId: item.serieDestinoId || item.SerieDestinoId,
      serieDestinoNome: item.serieDestinoNome || item.SerieDestinoNome || 'Série Destino não informada'
    }));
  }
  return [];
};

const getMensagemErro = (error) => {
  if (error && error.response && error.response.data) {
    const { mensagem, inconsistencias } = error.response.data;
    let msgFinal = mensagem || "Erro na operação.";

    if (inconsistencias && Array.isArray(inconsistencias) && inconsistencias.length > 0) {
      const detalhes = inconsistencias.map(inc => inc.mensagem).join(' - ');
      msgFinal = `${detalhes}`;
    }
    return msgFinal;
  }
  return "Erro de conexão ou servidor indisponível.";
};

/*#################################################################################################################*/
/* ---------------------------------- Actions Sagas --------------------------------------------------------------*/

function* fetchIniciaSequenciaEnturmacao() {
  try {
    // Chamada inicial para popular a grid
    const getSequencias = yield call([requisicaoApi, "get"], "/sequencias-enturmacao");
    
    if (getSequencias.status === 200) {
      const listaFormatada = formataLista(getSequencias.data);
      yield put(inicioSequenciaEnturmacaoSucesso(listaFormatada));
    } else {
      // Fallback para lista vazia em caso de erro na inicialização (evita tela travada)
      yield put(inicioSequenciaEnturmacaoSucesso([]));
      yield put({ type: ON_HIDE_LOADER });
    }
  } catch (error) {
    yield put(inicioSequenciaEnturmacaoSucesso([]));
    yield put({ type: ON_HIDE_LOADER });
  }
}

function* fetchListaSequenciaEnturmacao({ payload }) {
  try {
    let url = "/sequencias-enturmacao";
    if (payload) {
      if (typeof payload === 'string') {
         // Se for string, assume que é busca textual genérica se a API suportar, ou ignora
         // url += `?Texto=${payload}`;
      } else if (typeof payload === 'object') {
        const params = [];
        // Mapeando filtros para query params (ajustar conforme API real se necessário)
        if (payload.Texto) params.push(`search=${payload.Texto}`);
        if (payload.escolaId || payload.EscolaId) params.push(`escolaId=${payload.escolaId || payload.EscolaId}`);
        if (payload.cursoOrigemId || payload.CursoOrigemId) params.push(`cursoOrigemId=${payload.cursoOrigemId || payload.CursoOrigemId}`);
        if (payload.cursoDestinoId || payload.CursoDestinoId) params.push(`cursoDestinoId=${payload.cursoDestinoId || payload.CursoDestinoId}`);
        if (payload.serieOrigemId || payload.SerieOrigemId) params.push(`serieOrigemId=${payload.serieOrigemId || payload.SerieOrigemId}`);
        if (payload.serieDestinoId || payload.SerieDestinoId) params.push(`serieDestinoId=${payload.serieDestinoId || payload.SerieDestinoId}`);
        
        if (params.length > 0) {
          url += `?${params.join('&')}`;
        }
      }
    }

    const response = yield call([requisicaoApi, "get"], url);
    if (response.status === 200) {
      const listaFormatada = formataLista(response.data);
      yield put(listaSequenciaEnturmacaoSucesso(listaFormatada));
    } else {
      yield put(showAuthMessage("Não foi possível carregar a lista."));
    }
  } catch (error) {
    yield put(showAuthMessage("Erro ao buscar lista."));
  }
}

function* saveSequenciaEnturmacao({ payload }) {
  try {
    const method = payload.id ? "put" : "post";
    // Ajuste da rota conforme padrão REST (PUT requer ID na URL geralmente, ou no corpo)
    const route = payload.id ? `/sequencias-enturmacao/${payload.id}` : "/sequencias-enturmacao";
    
    const response = yield call([requisicaoApi, method], route, payload);

    if (response.status === 200 || response.status === 201) {
      yield put(salvaSequenciaEnturmacaoSucesso(response.data));
      // Atualiza a lista após salvar
      yield call(fetchListaSequenciaEnturmacao, {});
    } else {
      yield put(showAuthMessage("Erro ao salvar o registro. Verifique os dados."));
    }
  } catch (error) {
    yield put(showAuthMessage(getMensagemErro(error)));
  }
}

function* deleteSequenciaEnturmacao({ payload }) {
  try {
    const response = yield call([requisicaoApi, "delete"], `/sequencias-enturmacao/${payload}`);
    if (response.status === 200) {
      yield put(removeSequenciaEnturmacaoSucesso(payload));
      // Atualiza a lista após remover
      yield call(fetchListaSequenciaEnturmacao, {});
    } else {
      yield put(showAuthMessage("Erro ao remover o registro."));
    }
  } catch (error) {
    yield put(showAuthMessage(getMensagemErro(error)));
  }
}

function* getSequenciaEnturmacaoEdicao({ payload }) {
  try {
    const response = yield call([requisicaoApi, "get"], `/sequencias-enturmacao/${payload}`);
    if (response.status === 200) {
      yield put(buscaSequenciaEnturmacaoEdicaoSucesso(response.data));
    } else {
      yield put(showAuthMessage("Erro ao buscar dados para edição."));
      yield put({ type: ON_HIDE_LOADER });
    }
  } catch (error) {
    yield put(showAuthMessage("Erro de conexão ao buscar edição."));
    yield put({ type: ON_HIDE_LOADER });
  }
}

/*#################################################################################################################*/
/* ---------------------------------- Watchers -------------------------------------------------------------------*/

export function* watchIniciaSequenciaEnturmacao() {
  yield takeEvery(INICIA_SEQUENCIA_ENTURMACAO, fetchIniciaSequenciaEnturmacao);
}

export function* watchListaSequenciaEnturmacao() {
  yield takeEvery(LISTA_SEQUENCIA_ENTURMACAO, fetchListaSequenciaEnturmacao);
}

export function* watchSalvaSequenciaEnturmacao() {
  yield takeEvery(SALVA_SEQUENCIA_ENTURMACAO, saveSequenciaEnturmacao);
}

export function* watchRemoveSequenciaEnturmacao() {
  yield takeEvery(REMOVE_SEQUENCIA_ENTURMACAO, deleteSequenciaEnturmacao);
}

export function* watchBuscaSequenciaEnturmacaoEdicao() {
  yield takeEvery(BUSCA_SEQUENCIA_ENTURMACAO_EDICAO, getSequenciaEnturmacaoEdicao);
}

/*#################################################################################################################*/
/* ---------------------------------- Root Saga ------------------------------------------------------------------*/

export default function* rootSaga() {
  yield all([
    fork(watchIniciaSequenciaEnturmacao),
    fork(watchListaSequenciaEnturmacao),
    fork(watchSalvaSequenciaEnturmacao),
    fork(watchRemoveSequenciaEnturmacao),
    fork(watchBuscaSequenciaEnturmacaoEdicao)
  ]);
}
